"use scrict";

import grid from './parts/grid'

global.$ = require("jquery");
var MobileDetect = require('mobile-detect');

global.md = new MobileDetect(window.navigator.userAgent);
var mainWidth;

global.remToPx = function(x){
  return (parseInt($('html').css('font-size')) * x);
}

global.isTouchDevice = (('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0));

$(function(){
  vh();

  setTimeout(function(){
    $('body').addClass('in');

    $('video').each(function(){
      if(this.paused) {
        $(this).addClass('paused');
      }
    });
  }, 200);

  $(window).on('pageshow', function(){
    $(window).trigger('scroll');
    $('body').removeClass('out').addClass('in');
  });

  binds();

  $('.grid-wrap').each(function(){
    new grid(this);
  });
});


function binds(){
  $('.home .main > a').on('click', function(){
    $(this).addClass('force-hov');
  });

  $('a[href*="'+window.siteurl+'"]').on('click', function(e){
    if(e.ctrlKey || e.shiftKey || e.altKey || e.metaKey) {
    } else {
      e.preventDefault();
      $('body').addClass('out');
      var href = $(this).attr('href');
      setTimeout(function(){
        window.location = href;
      }, 600);
    }
  });

  $('.menu-button').on('click', function(e){
    e.preventDefault();
    $('.header').toggleClass('nav-in');
  });

  $('.main--wrap p').each(function(){
    var h = $(this).html();
    var svg = $('.logo > svg').clone();
    $(svg).css({
      'height': '0.65em',
      'margin-right': '0.15em',
      'vertical-align': '-0.05em',
    });
    svg = svg.get(0).outerHTML;
    h = h.replaceAll('<strong>mose</strong>', svg);
    $(this).html(h);
  });

  // if($('html').hasClass('artist') || $('html').hasClass('grid') || $('html').hasClass('projectpage')) {
    $(window).on('scroll', function(){
      $('video:not(.ok)').each(function(){
        if(this.getBoundingClientRect().top < window.innerHeight * 2) {
          $(this).children().attr('src', $(this).children().attr('data-src'));
          this.load();
          $(this).addClass('ok');
        }
      });

      $('iframe[data-src]').each(function(){
        if(this.getBoundingClientRect().top < window.innerHeight * 2) {
          $(this).attr('src', $(this).attr('data-src'));
          $(this).addClass('ok').removeAttr('data-src');
        }
      })
    });
  // }
  // if($('html').hasClass('artist') || $('html').hasClass('grid-artist')) {
  //   $(window).on('scroll', function(){
  //     // var top = $(window).scrollTop();
  //     // if(top > $('.grid-wrap').position().top + remToPx(8)){
  //     //   $('.banner').addClass('w');
  //     // } else {
  //     //   $('.banner').removeClass('w');
  //     // }

  //     if(top + window.innerHeight > document.scrollingElement.scrollHeight - remToPx(7)){
  //       $('.footer').addClass('d');
  //     } else {
  //       $('.footer').removeClass('d');
  //     }
  //   });

  //   $('.block--image img').on('click', function(){
  //     if(!isTouchDevice) {
  //       $('html').addClass('no-overflow');
  //       $('body').append('<div class="pop"><div class="pop--content"></div></div>');
  //       $('.pop--content').append($(this).clone());
  //       $('.pop').on('click', function(e){
  //         if(e.target==this) {
  //           $('.pop').remove();
  //         }
  //       });
  //     }
  //   });
  // }

  // $(window).scroll(function(){
  //   for(var i=0;i<window.blocks.length;i++) {
  //     var t = window.blocks[i];
  //     var rect = t.getBoundingClientRect();

  //     var inview = rect.top < window.innerHeight*.7 && rect.bottom > 0;

  //     if(inview){
  //       $(t).addClass('in');

  //       if(t.isHero) {
  //         console.log('ishero');
  //         let offsetPrc = Math.min(1, $(window).scrollTop() / window.innerHeight);
  //         let offset = -(100 * offsetPrc);
  //         $(t).css({
  //           'transform' : `translateY(${offset}px)`
  //           // 'transform' : `translate3d(-50%, calc(-50% + ${offset}px), 0)`
  //         });
  //       }
  //     } else {
  //       $(t).removeClass('in');
  //     }

  //     if(window.blocks[i].hasSparkles) {
  //       if(inview && !window.blocks[i].activeSparkles) {
  //         $(window.blocks[i]).find('.sparkles').addClass('in');
  //         window.blocks[i].activeSparkles = true;
  //       } else if(!inview){
  //         $(window.blocks[i]).find('.sparkles').removeClass('in');
  //         window.blocks[i].activeSparkles = false;
  //       }
  //     }
  //   }
  // });
}

function vh(){
  window.vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${window.vh}px`);
  $('#menuhooks.mobonly').css('top', $('.nav').outerHeight());
}

function resize(){
  let newMainWidth = $('main').outerWidth();
  if(newMainWidth!==mainWidth || !md.mobile()){
    vh();
  }
  mainWidth = newMainWidth;
}

$(window).on('resize', resize);

/*
function textFits(){
  $('.textfit').each(function(){
      var tar = $(this).parent();

      var h = $(this).parent().outerHeight();
      var w = $(this).parent().outerWidth();

      $(this).css({
        // 'height' : parseInt(h),
        'width' : parseInt(w),
      });

      var t = this;
      setTimeout(function(){
        textFit(
          t,
          {
            multiLine: true,
            minFontSize: 12,
            maxFontSize: remToPx(2.25),
            widthOnly: true,
          }
        );
      },1);
  });
}

window.textFits = textFits;
*/